import {
  ApartmentOutlined,
  MailOutlined,
  SettingOutlined,
  SwapOutlined,
  LeftOutlined,
  UserOutlined,
  RightOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
  AppstoreAddOutlined,
  UsergroupAddOutlined,
  BarChartOutlined,
  BranchesOutlined,
  DesktopOutlined,
  DollarOutlined
} from "@ant-design/icons";
import { Layout, Menu, Select, Button, Tooltip, Divider } from "antd";
import { useState, useEffect } from "react";
import VeoliaLogo from "./assets/VeoliaLogo";
import { useParams, useLocation } from "react-router-dom";
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";
import "./style/sidebar.css";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../redux/hooks";
const { Sider } = Layout;

const siderStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  borderRight: "1px solid rgba(0, 0, 0, 0.1)",
  height: '100vh',
  position: 'fixed',
  left: 0,
  top: 0,
  bottom: 0,
};

const logoStyle: React.CSSProperties = {
  height: "56px",
  lineHeight: "56px",
  fontSize: "32px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  padding: "0 16px"

  //  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  // paddingLeft: "16px",
};

const selectorStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: 208,
  margin: "8px auto",
  padding: "8px 0px",
};

const triggerButtonStyle: React.CSSProperties = {
  position: "absolute",
  top: "100px",
  right: -12,
  height: "24px",
  width: "24px",
  borderRadius: "50%",
  border: "1px solid rgba(0, 0, 0, 0.3)",
  padding: "0px",
};

type AppSidebarProps = {
  spaces: Array<{ spaceId: string; name: string; logoImage: string }>;
  updateParent: Function,
  userInfo: any,
  spaceEntitlements: Array<{}>;
};

const AppSidebar: React.FC<AppSidebarProps> = (props) => {
  const { spaces, updateParent, userInfo, spaceEntitlements } = props;
  const { companyLogo } = useAppSelector(state => state.company);
  const { limits } = useAppSelector(state => state.plan);

  // Check if PlanLimitBanner is visible
  const BANNER_HEIGHT = 44;
  const currentSpacesCount = userInfo?.spaceInfo?.length || 0;
  const spacesLimit = limits?.spaces || 0;
  const isSpacesLimitReached = spacesLimit > 0 && currentSpacesCount >= spacesLimit;
  const isBannerVisible = userInfo?.isAdmin && isSpacesLimitReached;

  const { spaceId } = useParams<{ spaceId: string }>();
  const [selectedMenu, setSelectedMenu] = useState("settings");
  const navigate = useTenantNavigation();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [customLogo, setCustomLogo] = useState(false);
  const { t, i18n } = useTranslation();

  const adminMenu = [
    {
      key: "organisation-structure",
      icon: <ApartmentOutlined />,
      label: t("Organisation Structure"),
    },
    {
      key: "workflow-configuration",
      icon: <DesktopOutlined />,
      label: t("Workflow Configuration"),
    },
    {
      key: "home-currency",
      icon: <DollarOutlined />,
      label: t("Home Currency"),
    },
  ]

  useEffect(() => {
    const selecteditem = pathname.substring(pathname.lastIndexOf("/") + 1);
    setSelectedMenu(selecteditem);
  }, [pathname]);

  const handleTriggerClick = () => {
    setCollapsed(!collapsed);
    setCustomLogo(!customLogo);
    updateParent()
  };

  const onChangeMenu = (value: any) => {
    setSelectedMenu(value.key);

    if (value.key === "organisation-structure") {
      navigate(`admin/configuration/organisation-structure`)
    } else if (value.key === "workflow-configuration") {
      navigate(`admin/configuration/workflow-configuration`)
    }
  };

  const onClick = () => {
    if (userInfo.isAdmin) {
      navigate("/app/dashboard")
    } else {
      navigate('/app/dashboard')
    }
  }

  return (
    <>
      <Sider
        width={collapsed ? "150px" : "240px"}
        trigger={null}
        style={{ ...siderStyle, top: isBannerVisible ? BANNER_HEIGHT : 0, height: isBannerVisible ? `calc(100vh - ${BANNER_HEIGHT}px)` : '100vh' }}
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        key={i18n.language}
      >
        <div style={logoStyle}>
          <VeoliaLogo type={customLogo ? "short" : "long"} onClick={onClick} companyLogo={companyLogo} />
        </div>
        <Divider className="space-sidebar-divider" style={{ margin: "7px 0 0 0" }} />

        {/* {collapsed ? (
          <>
            <p style={{ height: "0px" }}></p>
          </>
        ) : (
          <>
          {(!collapsed) && (
            <div
              style={{
                marginTop: "8px",
                marginBottom: "8px",
                fontWeight: 600,
                height: "50px",
                lineHeight: "50px",
                color: "#000000E0",
                paddingBottom: "8px", 
                borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              {showMenu === "space"
                ? t("Space Configuration")
                : t("Organisation Configuration")
                }
            </div>
          )}
            
          </>
        )} */}
        <Menu
          selectedKeys={[selectedMenu]}
          onClick={onChangeMenu}
          style={{ textAlign: "left", marginTop: "16px", padding: "0 1rem" }}
          items={adminMenu}
        />
        {!collapsed ? (
          <>
            <Button style={triggerButtonStyle} onClick={handleTriggerClick}>
              <LeftOutlined style={{ fontSize: "14px" }} />
            </Button>
          </>
        ) : (
          <>
            <Button style={triggerButtonStyle} onClick={handleTriggerClick}>
              <RightOutlined style={{ fontSize: "14px" }} />
            </Button>
          </>
        )}
      </Sider>
    </>
  );
};

export default AppSidebar;
